import { useRef } from "react";
import api, { formatApiErrorDetail } from "@/api/client";
import Layout from "@/components/Layout";
import { toast } from "sonner";
import { IDS } from "@/constants/testIds";

export default function Impostazioni() {
  const fileRef = useRef(null);

  const doExport = async () => {
    try {
      const { data } = await api.get("/backup");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `GymERP_backup_${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success("Backup scaricato");
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };
  const doImport = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!window.confirm("L'importazione sostituirà tutti i dati esistenti. Procedere?")) {
      e.target.value = ""; return;
    }
    try {
      const text = await f.text();
      const payload = JSON.parse(text);
      await api.post("/backup/import", payload);
      toast.success("Backup importato");
    } catch (err) {
      toast.error(err?.response ? formatApiErrorDetail(err.response.data?.detail) : "File non valido");
    } finally { e.target.value = ""; }
  };
  const doReset = async () => {
    if (!window.confirm("Cancellare definitivamente tutti i dati (prodotti, clienti, movimenti, ordini)?")) return;
    try { await api.post("/backup/reset"); toast.success("Archivio azzerato"); }
    catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail)); }
  };

  return (
    <Layout>
      <div className="section-title">
        <div><h2>Impostazioni</h2><p>Backup, importazione e manutenzione dei dati.</p></div>
      </div>
      <div className="panel">
        <div className="panel-body">
          <h3>Archivio server</h3>
          <p style={{ color: "var(--muted)" }}>GymERP salva i dati su database MongoDB. Puoi esportare un backup completo in JSON e reimportarlo in qualsiasi momento.</p>
          <div className="toolbar" style={{ marginTop: 14 }}>
            <button className="btn primary" onClick={doExport} data-testid={IDS.backupExport}>
              <i className="fa-solid fa-file-arrow-down" /> Scarica backup JSON
            </button>
            <button className="btn" onClick={() => fileRef.current?.click()}>
              <i className="fa-solid fa-file-arrow-up" /> Importa backup
            </button>
            <input ref={fileRef} type="file" accept=".json,application/json" hidden onChange={doImport} data-testid={IDS.backupImport} />
            <button className="btn danger" onClick={doReset} data-testid={IDS.backupReset}>
              <i className="fa-solid fa-trash" /> Azzera archivio
            </button>
          </div>
        </div>
      </div>
    </Layout>
  );
}
